import { call, put, select } from 'redux-saga/effects';
import moment from 'moment';
import { clone, concat, drop, filter, find, last, includes, is, isNil, isEmpty, join, keysIn, length, pickBy, propEq, split, toLower, values, ap } from 'ramda';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { AppActions, CompanyActions, DevelopActions, ManageActions } from '~/actions';
import { history } from '~/reducers';
import { convertUrl, isNotNull, messages } from '~/services/util';
import { QuotaCalcTypes, ToDoTypes, LibraryScoreCardsTabs } from '~/services/config';
import decamelize from '~/services/decamelize';
import NavigationService from '~/services/NavigationService';
import { uploadFile, AssetsURL } from '../services/BlobStorageApi';
import xmljs from 'xml-js';

export function* getlearnfeedsRequest(api, action) {
    try {
        const { id, target, payload, other, special, after } = action;

        if (isNil(payload.order)) payload.order = 'due_at';

        const options = queryString.stringify(pickBy(isNotNull, decamelize(payload)), {
            arrayFormat: 'bracket',
        });

        let others = [];
        let atype = target;
        let ctype = target;
        if (target === 'courses') {
            atype = 'training';
            others.push('card_type_id=1');
        } else if (target === 'habitslist') {
            atype = 'habitschedules';
        }
        if (special === 'assignments') {
            atype = 'training';
            others.push('card_type_id=1&status[]=0&status[]=1&status[]=2&status[]=4');
            ctype = 'carryOvers';
        }
        others.push(other);
        others = filter((e) => !isEmpty(e) && !isNil(e), others);
        others = join('&', others);

        const response = yield api.getLearnFeeds(atype, id, `${options}&${others}`);
        if (response.ok) {
            if (target === 'tracks') {
                for (let card of response.data.data) {
                    if (card.program_id) {
                        const resp = yield api.getCareerProgram(card.program_id);
                        card.program_title = resp?.data?.program?.title || '';
                    }
                }
            } else if (target === 'courses' || special === 'assignments') {
                for (let card of response.data.data) {
                    let completed = 0;
                    let remaining = 0;
                    let pastDue = 0;

                    for (let child of card.children) {
                        card.retention_quiz = child.card_type_id === 16;
                        if (child.status === 3) completed++;
                        else if (child.status === 2) pastDue++;
                        else remaining++;
                        child.data.attachments = isEmpty(child.data.attachments) ? [] : convertUrl(child.data.attachments);
                    }

                    card.data.completed = completed;
                    card.data.remaining = remaining;
                    card.data.past_due = pastDue;
                }
            }
            yield put(DevelopActions.getlearnfeedsSuccess({ type: ctype, data: response.data }));
            if (after) yield put({ ...after });
        } else {
            yield put(DevelopActions.getlearnfeedsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getlearnfeedsFailure());
    }
}

export function* postlibrarycardtemplatesRequest(api, action) {
    try {
        const { target, payload, route } = action;
        const { data } = payload;

        if (data?.data?.cards?.length > 0) {
            const templates = data.data.cards.map((card) => card.card_template_id || card.id);
            const options = `per_page=${templates.length}`;
            const response = yield api.postLibraryCardTemplates({ templates }, options);
            const result = { ...data, data: { ...data.data, cards: response.data.data } };
            yield put(DevelopActions.postlibrarycardtemplatesSuccess(target, result));
        } else {
            yield put(DevelopActions.postlibrarycardtemplatesFailure());
        }

        if (route) yield call(NavigationService.push, route);
    } catch (e) {
        yield put(DevelopActions.postlibrarycardtemplatesFailure());
    }
}

export function* getlibrarytemplatesRequest(api, action) {
    try {
        const { target, payload, route } = action;
        const { templates } = payload;

        const options = `per_page=${templates.length}`;
        const response = yield api.postLibraryCardTemplates({ templates }, options);
        if (response.ok) {
            yield put(DevelopActions.getlibrarytemplatesSuccess(target, response.data.data));
            if (route) yield call(NavigationService.push, route);
        } else {
            yield put(DevelopActions.getlibrarytemplatesFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getlibrarytemplatesFailure());
    }
}

export function* getlibrarytemplatessearchRequest(api, action) {
    try {
        const { target, payload, after } = action;

        const selectedTags = yield select((state) => state.app.selectedTags);
        const published = yield select((state) => state.app.published);

        const np = {
            ...payload,
            authorId: payload.authorId ?? selectedTags.authors,
            categoryId: payload.categoryId ?? selectedTags.categories,
            competencyId: payload.competencyId ?? selectedTags.competencies,
            departmentId: payload.departmentId ?? selectedTags.departments,
            published: payload.published ?? (published ? [1] : [0]),
            page: payload.page ?? 1,
            perPage: payload.perPage ?? 20,
        };

        let atype = target || 'tracks';
        let btype = atype;

        switch (target) {
            case 'tracks':
                break;
            case 'courses':
                break;
            case 'modules':
                np.cardTypeId = [3, 4, 5, 7, 14, 15];
                break;
            case 'habits schedules':
            case 'habitslist':
                np.cardTypeId = [17];
                atype = 'modules';
                btype = 'habitslist';
                break;
            case 'habits':
                np.cardTypeId = [8];
                atype = 'modules';
                break;
            case 'quotas':
                atype = 'quota_templates';
                break;
            case 'scorecards':
                break;
            case 'powerpoint':
            case 'power points':
                np.type = 'Power Point';
                atype = 'documents';
                btype = 'powerpoint';
                break;
            case 'word':
            case 'words':
                np.type = 'Word';
                atype = 'documents';
                btype = 'word';
                break;
            case 'pdf':
                np.type = 'PDF';
                atype = 'documents';
                break;
            case 'excel':
                np.type = 'Sheet';
                atype = 'documents';
                break;
            case 'envelope':
                np.cardTypeId = [8];
                np.type = 'Envelope';
                atype = 'documents';
                break;
            case 'careers':
                np.type = 1;
                atype = 'programs';
                break;
            case 'certifications':
                np.type = 2;
                atype = 'programs';
                break;
            case 'badges':
                np.type = 3;
                atype = 'programs';
                break;
            case 'assessment':
                np.cardTypeId = [2];
                atype = 'modules';
                break;
            case 'survey':
            case 'review':
                np.cardTypeId = [6];
                atype = 'modules';
                break;
            default:
                break;
        }

        const options = queryString.stringify(decamelize(pickBy(isNotNull, np)), {
            arrayFormat: 'bracket',
        });
        const response = yield api.getLibraryTemplatesSearch(atype, options);

        if (response.ok) {
            const templates = response.data;
            if (!isNil(response.data.data)) {
                templates.data = response.data.data.map((template) => {
                    template.data.thumb_url = convertUrl(template.data.thumb_url);
                    template.data.attachments = isEmpty(template.data.attachments) ? [] : convertUrl(template.data.attachments);
                    if (btype === 'tracks') {
                        template.thumbnail = template.thumbnail.includes('/[]') || template.thumbnail.includes('/attachments%2Fnull%2Fundefined') ? convertUrl('') : convertUrl(template.thumbnail);
                    }
                    if (!isNil(template.children)) {
                        template.children.data = template.children.map((children) => {
                            children.data.thumb_url = convertUrl(children.data.thumb_url);
                            children.data.attachments = isEmpty(children.data.attachments) ? [] : convertUrl(children.data.attachments);
                            return children;
                        });
                    }
                    return template;
                });
            }

            const modalData = yield select((state) => state.app.modalData);
            const data = clone(modalData);
            if (data?.before) {
                data.before.type = target;
                data.before.modules = templates.data;
            }
            yield put(AppActions.modalRequest({ type: null, data }));
            yield put(DevelopActions.getlibrarytemplatessearchSuccess(btype, templates));
            if (after) yield put({ ...after });
        } else {
            yield put(DevelopActions.getlibrarytemplatessearchFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getlibrarytemplatessearchFailure());
    }
}

export function* dailytrainingRequest(api, action) {
    try {
        const { userId } = action.payload;
        const now = moment().format('YYYY-MM-DD');

        let open = [],
            completed = [];

        let options = `per_page=500&page=1&date_start=${now}&date_end=${now}`;
        const openResponse = yield api.getLearnFeeds('daily', userId, options);

        if (openResponse.ok) {
            open = openResponse.data.today
                .filter((card) => card.archived !== 1)
                .map((card) => {
                    const completedModules = filter(({ status, completed_at }) => status === 3 || !isNil(completed_at), card.children);
                    const pastModules = filter(({ status }) => status === 2, card.children);
                    return {
                        ...card,
                        data: {
                            ...card.data,
                            completed: length(completedModules),
                            past_due: length(pastModules),
                        },
                    };
                });
        }

        options = `per_page=500&page=1&status[]=3&archived=1&completed_at_start=${now}`;
        const completedRes = yield api.getLearnFeeds('training', userId, options);

        if (completedRes.ok) completed = completedRes.data.data;

        yield put(DevelopActions.dailytrainingSuccess({ open, completed }));
    } catch (e) {
        yield put(DevelopActions.dailytrainingFailure());
    }
}

export function* updatecardinstanceRequest(api, action) {
    try {
        const { event, cardId, card, after, nextAfter, attachment } = action.payload;
        let cardData = card;

        if (!isNil(attachment) && !isNil(attachment.file)) {
            const res = yield api.getS3Info();
            if (res.ok) {
                const formData = new FormData();
                for (const key in res.data.inputs) {
                    formData.append(key, res.data.inputs[key]);
                }
                formData.set('Content-Type', attachment.file.type);
                formData.append('key', `attachments/${attachment.attachment_hash}/${attachment.file.name}`);
                formData.append('file', attachment.file);
                const response = yield api.fileUpload(formData);

                if (response.ok) {
                    const data = xmljs.xml2json(response.data, { compact: true, ignoreDeclaration: true });
                    const url = JSON.parse(data).PostResponse.Location._text;
                    cardData.data.attachment = url;
                }
            }
        }

        const response = yield api.updateCardInstance(cardId, event, { card: cardData });
        if (response.ok) {
            toast.success('Your action was successfully completed!', {
                position: toast.POSITION.TOP_RIGHT,
            });
            if (!isNil(after)) yield put({ ...after });
            if (!isNil(nextAfter)) yield put({ ...nextAfter });
            yield put(DevelopActions.updatecardinstanceSuccess());
        } else {
            toast.error('Oops, Your action cannot be completed!. Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.updatecardinstanceFailure());
        }
    } catch (e) {
        yield put(DevelopActions.updatecardinstanceFailure());
    }
}

export function* postscorecardsaveRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postScorecardSave(payload);
        const selected = yield select((state) => state.app.selectedTags);

        if (response.ok) {
            toast.success('The scorecard has been updated successfully!', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.postscorecardsaveSuccess(response.data));
            yield put(AppActions.advancedsearchRequest(selected, 'scorecards', response?.data?.scorecard?.published ?? 0, response?.data?.scorecard?.type ?? 0));
            yield call(NavigationService.goBack);
        } else {
            toast.error('Oops, Your action cannot be completed!. Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.postscorecardsaveFailure());
        }
    } catch (e) {
        yield put(DevelopActions.postscorecardsaveFailure());
    }
}

export function* libraryeventRequest(api, action) {
    try {
        const { target, event, id, data, after, route } = action;

        if (event === 'delete' && target === 'program') {
            const response = yield api.postDeleteLibraryEvent(id);

            if (response.ok) {
                if (response.data.response === 'success') {
                    if (after) yield put({ ...after });
                    toast.success(`The template was successfully deleted`, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    yield put(DevelopActions.libraryeventSuccess());
                } else {
                    toast.error(`Deleting the template was failed.`, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    yield put(DevelopActions.libraryeventFailure());
                }
            }
        }

        let canDelete = true;

        if (event === 'delete' && target !== 'scorecard' && target !== 'program') {
            let check = '';
            if (target === 'track') {
                check = yield api.getTrackCheck(id);
            } else if (target === 'quota_template') {
                check = yield api.getQuotaCheck(id);
            } else {
                check = yield api.getTemplateCheck(id);
            }
            canDelete = check.data.response === 'clear' || 'found';
        }

        if (target !== 'program') {
            if (canDelete) {
                const response = yield api.postDevLibraryEvent(target, event, id, data);

                if (response.ok) {
                    if (response.data.response === 'failure') {
                        toast.error(`${event === 'delete' ? 'Deleting' : 'Saving'} the template was failed. ${response.data.message}`, {
                            position: toast.POSITION.TOP_RIGHT,
                            pauseOnFocusLoss: false,
                            hideProgressBar: true,
                        });
                        yield put(DevelopActions.libraryeventFailure());
                    } else {
                        if (route) yield call(NavigationService.push, route);
                        if (after) yield put({ ...after });
                        toast.success(`The template was successfully ${event === 'delete' ? 'deleted' : 'saved'}.`, {
                            position: toast.POSITION.TOP_RIGHT,
                            pauseOnFocusLoss: false,
                            hideProgressBar: true,
                        });
                        if (target === 'track') {
                            const dateStart = moment(data.start_at).startOf('month').format('YYYY-MM-DD');
                            const dateEnd = moment(data.start_at).endOf('month').format('YYYY-MM-DD');
                            const payload = {
                                date_range_start: dateStart,
                                date_range_end: dateEnd,
                                page: 1,
                                per_page: 25,
                            };
                            yield put(DevelopActions.traininglistRequest(payload));
                        }
                        yield put(DevelopActions.libraryeventSuccess());
                        yield put(DevelopActions.getlibrarytemplatessearchRequest(data.target, data.payload));
                    }
                } else {
                    toast.error(`${event === 'delete' ? 'Deleting' : 'Saving'} the template was failed.`, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    yield put(DevelopActions.libraryeventFailure());
                }
            } else {
                toast.error(`Deleting the template was failed. Item has attached to track.`, {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                yield put(DevelopActions.libraryeventFailure());
            }
        }
    } catch (e) {
        yield put(DevelopActions.libraryeventFailure());
    }
}

export function* libraryprogramdetailRequest(api, action) {
    try {
        const { payload, mode, route } = action;
        const program = payload;

        if (isNil(program)) {
            yield put(DevelopActions.libraryprogramdetailSuccess(program, mode));
            return;
        }

        const { levels, description } = clone(program.data);
        let templateIds = [],
            trackIds = [],
            quota_templates = [];

        keysIn(levels).map((key) => {
            const level = levels[key];
            const { habits, quotas, trainings } = level;
            if (!isNil(habits)) {
                if (!habits.day) habits.day = [];
                if (!habits.week) habits.week = [];
                if (!habits.month) habits.month = [];
                let habitIds = habits.day;
                habitIds = concat(habitIds, habits.week);
                habitIds = concat(habitIds, habits.month);
                habitIds.map((item) => templateIds.push(item.id || item));
            }
            if (!isNil(quotas)) {
                const quotaIds = quotas.map((x) => x.quota_template_id);
                quota_templates = concat(quota_templates, quotaIds);
            }
            if (!isNil(trainings)) {
                trainings.items.map((item) => {
                    if (item.type === 'track') trackIds.push(item.item_id);
                    else templateIds.push(item.item_id);
                });
            }
        });

        let tracks = [];
        let options = `per_page=${trackIds.length}`;
        if (trackIds.length > 0) {
            const response1 = yield api.postLibraryCardTemplates({ tracks: trackIds }, options);
            tracks = response1.ok && response1.data.response !== 'error' ? response1.data.data : [];
        }

        let cardTemplates = [];
        if (templateIds.length > 0) {
            options = `per_page=${templateIds.length}`;
            const response2 = yield api.postLibraryCardTemplates({ templates: templateIds }, options);
            cardTemplates = response2.ok && response2.data.response !== 'error' ? response2.data.data : [];
        }

        let quotaCards = [];
        if (quota_templates.length > 0) {
            options = `per_page=${quota_templates.length}`;
            const response3 = yield api.postLibraryCardTemplates({ quota_templates }, options);
            quotaCards = response3.ok && response3.data.response !== 'error' ? response3.data.data : [];
        }

        let newLevels = {};
        keysIn(levels).map((key) => {
            const level = levels[key];
            const { habits, quotas, trainings } = level;
            newLevels[key] = { ...level };
            if (!isNil(habits)) {
                const day = [];
                habits.day.map((habit) => {
                    const item = find(propEq('id', habit.id || habit), cardTemplates);
                    if (!isNil(item)) day.push(item);
                });
                const week = [];
                habits.week.map((habit) => {
                    const item = find(propEq('id', habit.id || habit), cardTemplates);
                    if (!isNil(item)) week.push(item);
                });
                const month = [];
                habits.month.map((habit) => {
                    const item = find(propEq('id', habit.id || habit), cardTemplates);
                    if (!isNil(item)) month.push(item);
                });
                newLevels[key] = { ...newLevels[key], habits: { day, week, month } };
            }
            if (!isNil(quotas)) {
                const newQuotas = [];
                quotas.map((x) => {
                    const quota = find(propEq('id', Number(x.quota_template_id)), quotaCards);
                    if (!isNil(quota)) newQuotas.push({ ...quota, ...x });
                });
                newLevels[key] = { ...newLevels[key], quotas: newQuotas };
            }
            let trainingDetails = tracks;
            if (!isNil(trainings)) {
                const newTrainings = [];
                trainings.items.map((item) => {
                    trainingDetails = item.type === 'track' ? tracks : cardTemplates;
                    const e = find(propEq('id', Number(item.item_id)), trainingDetails);
                    if (!isNil(e)) newTrainings.push({ ...e, ...item });
                });
                newLevels[key] = { ...newLevels[key], trainings: { ...trainings, items: newTrainings } };
            }
        });

        const response = { ...program, data: { ...program.data, description, levels: newLevels } };

        yield put(DevelopActions.libraryprogramdetailSuccess(response, mode));
        if (route) yield call(NavigationService.push, route.pathname || route);
    } catch (e) {
        yield put(DevelopActions.libraryprogramdetailFailure());
    }
}

export function* quotatemplatesRequest(api, action) {
    try {
        const { id, mode, templateIds } = action;
        const options = `per_page=500`;
        const response = yield api.postLibraryCardTemplates({ quota_templates: templateIds }, options);
        const quotas = response.data.data || [];
        if (response.ok) {
            yield put(DevelopActions.quotatemplatesSuccess(id, mode, quotas));
        } else {
            yield put(DevelopActions.quotatemplatesFailure());
        }
    } catch (e) {
        yield put(DevelopActions.quotatemplatesFailure());
    }
}

export function* trainingscheduledetailRequest(api, action) {
    const schedule = action.payload;
    const cards = schedule.data.cards || [];
    const templates = cards.map((card) => card.card_template_id);
    const options = `per_page=${length(templates)}`;

    try {
        const response = yield api.postLibraryCardTemplates({ templates }, options);
        if (response.ok) {
            let newCards = cards.map((card) => {
                const detail = find(propEq('id', Number(card.card_template_id)), response.data.data);
                return { ...card, ...detail };
            });
            newCards = filter((x) => !!x.id, newCards);

            yield put(
                DevelopActions.trainingscheduledetailSuccess({
                    ...schedule,
                    data: { ...schedule.data, cards: newCards },
                })
            );
        } else {
            yield put(
                DevelopActions.trainingscheduledetailFailure({
                    ...schedule,
                    data: { ...schedule.data, cards: [] },
                })
            );
        }
    } catch (e) {
        yield put(
            DevelopActions.trainingscheduledetailFailure({
                ...schedule,
                data: { ...schedule.data, cards: [] },
            })
        );
    }
}

export function* librarytemplatesaveRequest(api, action) {
    try {
        const { payload, files, target, after, route, callback } = action;
        const viewMode = target || 'courses';
        let pptHash;

        if (files) {
            for (const file of files) {
                if (file) {
                    if (file?.length > 1) {
                        for (const i in file) {
                            if (!file[i]?.name) continue;
                            
                            const upload = yield uploadFile(file[i]);

                            if (upload?.url) {
                                payload.template.data.attachments = [...payload.template.data.attachments, upload.url];
                            }
                        }
                    } else {
                        if (!file?.name) continue;

                        const upload = yield uploadFile(file);
                        
                        if (upload?.url) {
                            if (upload.meta.isImage) {
                                if (viewMode === 'tracks') {
                                    payload.track.thumbnail = upload.url;
                                } else {
                                    if (payload?.template) payload.template.data.thumb_url = upload.url;
                                    if (payload?.assessment) payload.assessment.data.thumb_url = upload.url;
                                }
                            } else if (upload.meta.isVideo) {
                                payload.template.data.video_url = upload.url;
                            } else if (upload.meta.isPdf) {
                                payload.template.data.attachments = [...payload.template.data.attachments, upload.url];
                            } else {
                                if (payload.template.card_type_id === 15) {
                                    payload.template.data.presentation_url = drop(AssetsURL.length, upload.url);
                                } else {
                                    payload.template.data.attachments = [...payload.template.data.attachments, upload.url];
                                }
                                if (upload.meta.isPowerPoint) pptHash = upload.hash;
                            }
                        }
                    }
                }
            }
        }

        let type = '';
        if (viewMode === 'tracks') type = 'track';
        else if (viewMode === 'scorecards') type = 'scorecard';
        else type = 'template';

        if (viewMode === 'modules' && payload?.assessment) {
            const data = { assessment: payload.assessment };
            const response = yield api.postDevLibraryCardSave(data, 'assessments');
            if (response.ok) {
                const quizData = {
                    template: {
                        ...payload.data,
                        data: {
                            ...payload.data.data,
                            thumb_url: payload.assessment.data.thumb_url,
                            assessment_id: response.data.id,
                        },
                    },
                };

                const res = yield api.postDevLibraryCardSave(quizData, 'template');
                if (res.ok) {
                    toast.success('Your quiz module was successfully saved.', {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });

                    if (after) yield put({ ...after });
                    if (route) yield call(NavigationService.push, route);
                    if (callback) yield callback(res.data);
                    yield put(DevelopActions.librarytemplatesaveSuccess());
                    return;
                }
            }
            toast.error('Oops, Your action cannot be completed!. Please try again', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.librarytemplatesaveFailure());
            return;
        }

        const response = yield api.postDevLibraryCardSave(payload, type);

        if (response.ok && response.data.response !== 'failure') {
            yield put(DevelopActions.librarytemplatesaveSuccess(payload));

            if (pptHash && files[2]) {
                yield api.postPresentationSave({
                    file: `attachments/${pptHash.data}/${files[2].name}`,
                    location: `attachments/${pptHash.data}`,
                    template_id: response.data.template.id,
                });
            }

            toast.success(messages(viewMode), {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });

            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);

            /**
             * This functionality would be worked for ADD COURSE functionality
             * to put newly created modules to the request to create new courses.
             */
            if (viewMode === 'courses') {
                const modalData = yield select((state) => state.app.modalData);
                if (modalData?.after?.modules) {
                    const modules = modalData.after.modules;
                    let afterData = [];
                    if (modules && !isEmpty(modules)) afterData = modules;
                    afterData = afterData.concat([response.data.template]);
                    if (callback) yield callback(afterData);
                    yield put(AppActions.modalRequest({ type: '', data: { after: afterData } }));
                }
            }

            if (viewMode === 'modules') {
                const modalData = yield select((state) => state.app.modalData);
                if (modalData?.after?.modules) {
                    const modules = modalData.after.modules;
                    let afterData = [];
                    if (modules && !isEmpty(modules)) afterData = modules;
                    afterData = afterData.concat([response.data.template]);
                    if (callback) yield callback(afterData);
                    yield put(AppActions.modalRequest({ type: '', data: { after: { modules: afterData } } }));
                }
            }

            if (viewMode === 'habits') {
                const modalData = yield select((state) => state.app.modalData);
                if (modalData?.after?.habits) {
                    const habits = modalData.after.habits;
                    let afterData = [];
                    if (habits && !isEmpty(habits)) afterData = habits;
                    afterData = afterData.concat([response.data.template]);
                    if (callback) yield callback(afterData);
                    yield put(
                        AppActions.modalRequest({
                            type: '',
                            data: { after: { habits: afterData } },
                        })
                    );
                }
            }
        } else {
            toast.error(`Editing the ${viewMode} failed. ${response.data.message}`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.librarytemplatesaveFailure());
        }
    } catch (e) {
        yield put(DevelopActions.librarytemplatesaveFailure());
    }
}

export function* librarycardtemplatesRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postLibraryCardTemplates(payload);
        if (response.ok) {
            yield put(DevelopActions.librarycardtemplatesSuccess(response.data.data));
        } else {
            yield put(DevelopActions.librarycardtemplatesFailure());
        }
    } catch (e) {
        yield put(DevelopActions.librarycardtemplatesFailure());
    }
}

export function* librarysaveRequest(api, action) {
    try {
        const { payload, image, pdf, after } = action;
        const { type, data, baseUrl } = payload;

        if (!isNil(image) && !isEmpty(image)) {
            const _payload = { attachment_hash: null, file: image };
            const res = yield api.getS3Info();

            if (res.ok) {
                const formData = new FormData();
                for (const key in res.data.inputs) {
                    formData.append(key, res.data.inputs[key]);
                }
                formData.set('Content-Type', _payload.file.type);
                formData.append('key', `attachments/${_payload.attachment_hash}/${_payload.file.name}`);
                formData.append('file', _payload.file);
                const response = yield api.fileUpload(formData);

                if (response.ok) {
                    const imageData = xmljs.xml2json(response.data, {
                        compact: true,
                        ignoreDeclaration: true,
                    });
                    const url = JSON.parse(imageData).PostResponse.Location._text;
                    data.program.data.thumb_url = url;
                }
            }
        }

        if (!isNil(pdf)) {
            const _payload = { attachment_hash: null, file: pdf };
            const res = yield api.getS3Info();

            if (res.ok) {
                const formData = new FormData();
                for (const key in res.data.inputs) {
                    formData.append(key, res.data.inputs[key]);
                }
                formData.set('Content-Type', _payload.file.type);
                formData.append('key', `attachments/${_payload.attachment_hash}/${_payload.file.name}`);
                formData.append('file', _payload.file);
                const response = yield api.fileUpload(formData);

                if (response.ok) {
                    const pdfData = xmljs.xml2json(response.data, { compact: true, ignoreDeclaration: true });
                    const url = JSON.parse(pdfData).PostResponse.Location._text;
                    data.program.data.attachments = [url];
                }
            }
        }

        let mode = '';
        if (type === 'careers' || type === 'certifications' || type === 'badges') mode = 'program';
        else if (type === 'habits' || type === 'habitslist') mode = 'template';
        else if (type === 'quotas') mode = 'quota_template';
        else if (type === 'scorecards') mode = 'scorecard';
        else mode = type;

        const response = yield api.postDevLibraryCardSave(data, mode);
        if (response.ok) {
            if (response.data.response === 'failure') {
                toast.error(`Saving the template failed. ${response.data.message}`, {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                yield put(DevelopActions.librarysaveFailure());
            } else {
                yield put(DevelopActions.librarysaveSuccess(response.data, mode));
                if (mode === 'program') {
                    toast.success(`Your program was successfully ${data.program.id ? 'saved' : 'added'}.`, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    yield call(NavigationService.push, type === 'certifications' ? '/library/certification/certifications' : '/library/programs');
                }
                if (includes(type, ToDoTypes)) {
                    let msg = '';
                    if (type === 'habits') {
                        msg = `Your habit card was successfully ${data.template.id ? 'saved' : 'added'}.`;
                    }
                    if (type === 'habitslist') {
                        msg = `Your habit schedule card was successfully ${data.template.id ? 'saved' : 'added'}.`;
                    }
                    if (type === 'quotas') {
                        msg = `Your quota card was successfully ${data.quota_template.id ? 'saved' : 'added'}.`;
                    }
                    if (type === 'scorecards') {
                        msg = `Your scorecard was successfully ${data.scorecard.id ? 'saved' : 'added'}.`;
                    }
                    toast.success(msg, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    if (type === 'scorecards') {
                        const activeTab = LibraryScoreCardsTabs.find((t) => t.id === data.scorecard.type);
                        yield call(NavigationService.push, `/library/scorecards?active=${activeTab.name}`);
                        return;
                    }

                    if (baseUrl) {
                        yield call(NavigationService.goBack);
                    } else {
                        if (type !== 'quotas') {
                            yield call(NavigationService.push, `/library/to-do?active=${type}`);
                        }
                    }
                }
                if (type === 'track') {
                    if (data.track.type === 3) {
                        const msg = `Your training schedule was successfully ${data.track.id ? 'saved' : 'added'}.`;
                        toast.success(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                            pauseOnFocusLoss: false,
                            hideProgressBar: true,
                        });
                        yield call(NavigationService.push, '/hcm/report-training-schedule');
                    }
                }
                if (after) yield put({ ...after });
            }
        } else {
            yield put(DevelopActions.librarysaveFailure());
            if (mode === 'program') {
                toast.error(`${data.program.id ? 'Updating' : 'Adding'} your program was failed. Please retry it again. If you can't add one, please contact our support.`, {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
            }
            if (includes(type, ToDoTypes)) {
                let msg = '';
                if (type === 'habits') {
                    msg = `${data.template.id ? 'Updating' : 'Adding'} your habit was failed. Please retry it again. If you can't add one, please contact our support.`;
                }
                if (type === 'habitslist') {
                    msg = `${data.template.id ? 'Updating' : 'Adding'} your habit schedule was failed. Please retry it again. If you can't add one, please contact our support.`;
                }
                if (type === 'quotas') {
                    msg = `${data.quota_template.id ? 'Updating' : 'Adding'} your quota was failed. Please retry it again. If you can't add one, please contact our support.`;
                }
                if (type === 'scorecards') {
                    msg = `${data.scorecard.id ? 'Updating' : 'Adding'} your scorecard was failed. Please retry it again. If you can't add one, please contact our support.`;
                }
                toast.error(msg, {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
            }
            if (type === 'track') {
                if (data.track.type === 3) {
                    const msg = `${data.track.id ? 'Saving' : 'Adding'} your training schedule was failed.`;
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                }
            }
        }
    } catch (e) {
        yield put(DevelopActions.librarysaveFailure());
    }
}

export function* questionRequest(api, action) {
    try {
        const { quizId } = action;
        const response = yield api.getQuizQuestion(quizId);

        if (response.ok) {
            const { data } = response;
            const res = {
                num: data.current ? data.current.item : 0,
                type: data.item ? Number(data.item.type) : 0,
                options: data.item && data.item.rules ? values(data.item.rules.options) : [],
                title: data.item ? data.item.wording : '',
                completed: data.complete ? data.complete : false,
                result: data.info && data.info.result ? data.info.result.result : {},
                message: data.message,
            };
            yield put(DevelopActions.questionSuccess(res));
        } else {
            yield put(DevelopActions.questionFailure());
        }
    } catch (e) {
        yield put(DevelopActions.questionFailure());
    }
}

export function* answerRequest(api, action) {
    try {
        const { quizId, payload } = action;
        const response = yield api.submitAnswer(quizId, payload);

        if (response.ok) {
            const res = { correct: 0, answer: '', error: false };

            if (response.data.correct) {
                res.correct = response.data.correct.correct;
                res.answer = response.data.correct.answer;
                yield put(DevelopActions.answerSuccess(res));
            } else {
                res.error = true;
                yield put(DevelopActions.answerSuccess(res));
            }

            const { data } = response;
            const nextQuestion = {
                num: data.current ? data.current.item : 0,
                type: data.item ? Number(data.item.type) : 0,
                options: data.item && data.item.rules ? values(data.item.rules.options) : [],
                title: data.item ? data.item.wording : '',
                completed: data.complete ? data.complete : false,
                result: data.info && data.info.result ? data.info.result.result : {},
                message: data.message,
            };
            yield put(DevelopActions.questionSuccess(nextQuestion));
            if (data.complete) yield updateLearnFeed(api);
        } else {
            yield put(DevelopActions.answerFailure());
        }
    } catch (e) {
        yield put(DevelopActions.answerFailure());
    }
}

export function* resetquizRequest(api, action) {
    try {
        const { quizId } = action;
        const response = yield api.resetQuiz(quizId);
        if (response.ok) {
            if (response.data.reset) yield questionRequest(api, { quizId });
            yield put(DevelopActions.resetquizSuccess());
        } else {
            yield put(DevelopActions.resetquizFailure());
        }
    } catch (e) {
        yield put(DevelopActions.resetquizFailure());
    }
}

export function* createquotaRequest(api, action) {
    try {
        const { payload, after } = action;
        const modalData = yield select((state) => state.app.modalData);

        const response = yield api.postDevLibraryCreateQuota(payload);
        if (response.ok) {
            toast.success('Quota created successfully', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });

            if (after) yield put({ ...after });

            if (modalData?.after?.quotas) {
                const quotas = modalData.after.quotas;
                let afterData = [];
                if (quotas && !isEmpty(quotas)) afterData = quotas;
                afterData = afterData.concat([response.data.quota_template]);
                yield put(
                    AppActions.modalRequest({
                        type: '',
                        data: { after: { quotas: afterData } },
                    })
                );
            }
            yield put(DevelopActions.createquotaSuccess());
            yield put(
                DevelopActions.getlibrarytemplatessearchRequest(
                    'quotas',
                    {
                        search: '',
                        page: 1,
                        perPage: 10,
                        quotaTracking: response?.data?.quota_template?.quota_tracking ?? 0,
                    },
                    after?.after
                )
            );
        } else {
            yield put(DevelopActions.createquotaFailure());
        }
    } catch (e) {
        yield put(DevelopActions.createquotaFailure());
    }
}

export function* getquotaoptionsRequest(api, action) {
    try {
        const response = yield api.getQuotaOptions();
        if (response.ok) {
            const { calculations } = response.data;
            const options = keysIn(calculations).map((key) => ({
                id: QuotaCalcTypes[key].id,
                label: QuotaCalcTypes[key].label,
                value: calculations[key],
            }));
            yield put(DevelopActions.getquotaoptionsSuccess(options));
        }
    } catch (e) {
        yield put(DevelopActions.getquotaoptionsFailure());
    }
}

export function* adddocumentRequest(api, action) {
    try {
        const { payload, attachment } = action;
        if (!isNil(attachment)) {
            const _payload = { attachment_hash: null, file: attachment };
            const res = yield api.getS3Info();

            if (res.ok) {
                const formData = new FormData();
                for (const key in res.data.inputs) {
                    formData.append(key, res.data.inputs[key]);
                }
                formData.set('Content-Type', _payload.file.type);
                formData.append('key', `attachments/${_payload.attachment_hash}/${_payload.file.name}`);
                formData.append('file', _payload.file);
                const response = yield api.fileUpload(formData);

                if (response.ok) {
                    const data = xmljs.xml2json(response.data, { compact: true, ignoreDeclaration: true });
                    const url = JSON.parse(data).PostResponse.Location._text;
                    payload.document.data.attachment = url;
                }
            }
        }

        const response = yield api.postDevLibraryAddDocument(payload);
        if (response.ok) {
            yield put(AppActions.modalRequest({ type: '' }));
            yield put(DevelopActions.adddocumentSuccess());
            toast.success('File updated successfully', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield call(NavigationService.push, '/library/documents');
        } else {
            yield put(DevelopActions.adddocumentFailure());
        }
    } catch (e) {
        yield put(DevelopActions.adddocumentFailure());
    }
}

export function* deletedocumentRequest(api, action) {
    try {
        const { id, target, filter } = action.payload;

        const response = yield api.postDevLibraryDeleteDocument(id);
        if (response.ok) {
            yield put(AppActions.modalRequest({ type: '' }));
            toast.success('Document successfully deleted.', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.deletedocumentSuccess());
            yield put(DevelopActions.getlibrarytemplatessearchRequest(target, filter));
        } else {
            toast.success('Deleting document failed, please try it later.', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.deletedocumentFailure());
        }
    } catch (e) {
        toast.success('Deleting document failed, please try it later.', {
            position: toast.POSITION.TOP_RIGHT,
        });
        yield put(DevelopActions.deletedocumentFailure());
    }
}

export function* careergoalsRequest(api, action) {
    try {
        const { id } = action;
        const response = yield api.getCareerGoals(id);

        if (response.ok) {
            yield put(DevelopActions.careergoalsSuccess(response.data));
        } else {
            yield put(DevelopActions.careergoalsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careergoalsFailure());
    }
}

export function* careergoalsaveRequest(api, action) {
    try {
        const { id, data } = action;
        const response = yield api.postCareerGoals(id, data);

        if (response.ok) {
            yield put(DevelopActions.careergoalsaveSuccess(data.goals));
        } else {
            yield put(DevelopActions.careergoalsaveFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careergoalsaveFailure());
    }
}

export function* careerdevreportsRequest(api, action) {
    try {
        const { companyId, userId } = action;
        const response = yield api.getCareerDevReports(companyId, userId);

        if (response.ok) {
            const programs = [];
            const habits = [];
            const requirements = [];
            const developments = [];
            const jobs = [];
            let current = 0;
            if (response.data.status === 'error') {
                yield put(
                    DevelopActions.careerdevreportsSuccess({
                        message: response.data.message,
                        programs,
                        requirements,
                        habits,
                        developments,
                        current,
                        jobs,
                    })
                );
            } else {
                values(response.data.job_titles).forEach((job, index) => {
                    if (job.active) current = index;
                    if (is(Object, job.program)) {
                        programs.push({
                            ...job.program,
                            months: job.program.data.months,
                            job_status: job.active ? 'current' : job.archived ? 'completed' : 'not started',
                        });
                        requirements.push(values(job.program.data.achievements));
                    }
                    habits.push(job.habits);
                    jobs.push(job.job_title);
                    if (job.courses) developments.push(Object.values(job.courses));
                });
                yield put(
                    DevelopActions.careerdevreportsSuccess({
                        programs,
                        requirements,
                        habits,
                        developments,
                        current,
                        jobs,
                        message: '',
                    })
                );
            }
        } else {
            yield put(DevelopActions.careerdevreportsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careerdevreportsFailure());
    }
}

export function* careertasksRequest(api, action) {
    try {
        const { userId, perPage, page } = action;
        const response = yield api.getLearnFeed(userId, perPage, page, 8);
        if (response.ok) {
            yield put(DevelopActions.careertasksSuccess(response.data));
        } else {
            yield put(DevelopActions.careertasksFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careertasksFailure());
    }
}

export function* careertrainingsRequest(api, action) {
    try {
        const { userId, perPage, page } = action;
        const response = yield api.getLearnFeed(userId, perPage, page, 1);
        if (response.ok) {
            yield put(DevelopActions.careertrainingsSuccess(response.data));
        } else {
            yield put(DevelopActions.careertrainingsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careertrainingsFailure());
    }
}

export function* careerpromoteRequest(api, action) {
    try {
        // get user id
        const getUserId = (state) => state.app.id;
        const userId = yield select(getUserId);
        // get company id
        const { companyId } = action;

        const response = yield api.requestPromote(companyId, userId);
        if (response.ok) {
            if (response.data.response === 'success') {
                toast.success('Your request is successfully created.', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                yield put(DevelopActions.careerpromoteSuccess(response.data.card_instance));
            } else if (response.data.response === 'exists') {
                toast.success('Your request was already created.', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                const res = yield api.updateCardInstance(response.data.card_instance.id);
                if (res.ok) {
                    yield put(DevelopActions.careerpromoteSuccess(res.data));
                } else {
                    yield put(DevelopActions.careerpromoteSuccess(response.data.card_instance));
                }
            } else if (response.data.response === 'error') {
                toast.error('Sorry, you have no a manager defined in your company or you are not in an active program for your company', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                yield put(DevelopActions.careerpromoteFailure());
            }
        } else {
            yield put(DevelopActions.careerpromoteFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careerpromoteFailure());
    }
}

export function* careerApprovalTaskRequest(api, action) {
    try {
        // get user id
        const userId = yield select((state) => state.app.id);
        // get company id
        const currentCompanyInfo = yield select((state) => state.app.company_info);

        const { name, description } = action.payload;

        const payload = {
            card: {
                card_template_id: null,
                card_type_id: 8,
                parent_id: null,
                data: {
                    name: name,
                    description: description,
                    company_id: currentCompanyInfo.id,
                    promote_user_id: userId,
                    type: 'single',
                },
                project_id: 1,
            },
            user_id: [2],
        };

        const response = yield api.createCard(payload);

        if (response.ok) {
            if (response.data.success) yield put(DevelopActions.careercardSuccess(response.data.cards[0]));
            else yield put(DevelopActions.careercardFailure());
        } else {
            yield put(DevelopActions.careercardFailure());
        }
    } catch (e) {
        yield put(DevelopActions.careercardFailure());
    }
}

export function* adddevcommentRequest(api, action) {
    try {
        const { payload, act } = action;
        const { card_instance_id } = payload.comment;

        const response = yield api.addComment(payload);
        if (response.ok) {
            const res = yield api.updateCardInstance(card_instance_id);
            if (res.ok) {
                if (act === 'career-comment') yield put(DevelopActions.careerpromoteSuccess(res.data));
            }
            yield put(DevelopActions.adddevcommentSuccess());
        } else {
            yield put(DevelopActions.adddevcommentFailure());
        }
    } catch (e) {
        yield put(DevelopActions.adddevcommentFailure());
    }
}

export function* userscoursereportRequest(api, action) {
    try {
        const { userId, dateStart, dateEnd } = action;
        const response = yield api.getUsersCourseRequest(userId, dateStart, dateEnd);

        if (response.ok) {
            response.data = response.data.map((item) => {
                item.data.thumb_url = convertUrl(item.data.thumb_url);
                return item;
            });
            yield put(DevelopActions.userscoursereportSuccess(response.data));
        } else {
            yield put(DevelopActions.userscoursereportFailure());
        }
    } catch (e) {
        yield put(DevelopActions.userscoursereportFailure());
    }
}

export function* teamreportsRequest(api, action) {
    try {
        const { id, dateStart, dateEnd } = action;
        const payload = {
            company_id: id,
            date_start: moment(dateStart).format('YYYY-MM-DD'),
            date_end: moment(dateEnd).format('YYYY-MM-DD'),
        };
        const response = yield api.getTrainingReports(payload);
        if (response.ok) {
            yield put(DevelopActions.teamreportsSuccess(response.data));
        } else {
            yield put(DevelopActions.teamreportsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.teamreportsFailure());
    }
}

export function* traininglistRequest(api, action) {
    try {
        const { payload } = action;
        payload.type = 3;
        const options = queryString.stringify(payload);
        const response = yield api.getLibrarySearch('tracks', options);

        if (response.ok) {
            yield put(DevelopActions.traininglistSuccess(response.data));
        } else {
            yield put(DevelopActions.traininglistFailure());
        }
    } catch (e) {
        yield put(DevelopActions.traininglistFailure());
    }
}

export function* updatemoduleRequest(api, action) {
    try {
        const { payload } = action;
        const request = {
            id: payload.id,
            data: { card: { card_template_id: payload.card_template_id, data: payload.data } },
        };
        const response = yield api.updateModule(request);
        if (response.ok) {
            yield put(DevelopActions.updatemoduleSuccess());
            const modalData = clone(yield select((state) => state.app.modalData));
            modalData.before.module = response.data;
            yield put(AppActions.modalRequest({ type: null, data: modalData }));
        } else {
            yield put(DevelopActions.updatemoduleFailure());
        }
    } catch (e) {
        yield put(DevelopActions.updatemoduleFailure());
    }
}

export function* getscormlinkRequest(api, action) {
    try {
        const { courseId, cardId } = action;
        const response = yield api.getScormLink(cardId);

        if (response.ok) {
            yield put(DevelopActions.getscormlinkSuccess(courseId, cardId, response.data.link));
        } else {
            yield put(DevelopActions.getscormlinkFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getscormlinkFailure());
    }
}

export function* updatecardRequest(api, action) {
    try {
        const { event, cardId, page, perPage, after } = action;
        const response = yield api.updateCard(event, cardId);
        if (response.ok) {
            //yield updateLearnFeed(api); // This was failing and causing a crash. Not sure if needed.
            const userId = yield select((state) => state.app.id);
            yield put(
                DevelopActions.getlearnfeedsRequest(userId, 'courses', {
                    page,
                    perPage: perPage,
                    sort: 'ASC',
                })
            );
            yield put(DevelopActions.updatecardSuccess());
            yield put(ManageActions.updatetaskSuccess({ event, cardId }));
            if (after) yield put({ ...after });
        } else {
            yield put(DevelopActions.updatecardFailure());
        }
    } catch (e) {
        yield put(DevelopActions.updatecardFailure());
    }
}

export function* postcompanyinfoRequest(api, action) {
    try {
        const { payload, companyId } = action;
        const response = yield api.postDevRecordsCompany(payload, companyId);

        if (response.ok) {
            yield put(DevelopActions.postcompanyinfoSuccess());
            yield put(AppActions.getcompanyRequest(companyId));
            yield put(AppActions.getcompaniesRequest());
        } else {
            yield put(DevelopActions.postcompanyinfoFailure());
        }
    } catch (e) {
        yield put(DevelopActions.postcompanyinfoFailure());
    }
}

export function* fetchnotificationssettingsRequest(api, action) {
    try {
        const response = yield api.getDevRecordsNotificationsSettings();
        if (response.ok) {
            yield put(DevelopActions.fetchnotificationssettingsSuccess(response.data));
        } else {
            yield put(DevelopActions.fetchnotificationssettingsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.fetchnotificationssettingsFailure());
    }
}

export function* updatenotificationssettingsRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.postDevRecordsNotificationsSettings(payload);
        if (response.ok) {
            yield put(DevelopActions.updatenotificationssettingsSuccess(response.data));
            toast.success('Your settings are successfully updated.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        } else {
            yield put(DevelopActions.updatenotificationssettingsFailure());
            toast.error('Updating your settins are failed, please try it later.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
    } catch (e) {
        yield put(DevelopActions.updatenotificationssettingsFailure());
        toast.error('Updating your settins are failed, please try it later.', {
            position: toast.POSITION.TOP_RIGHT,
            pauseOnFocusLoss: false,
            hideProgressBar: true,
        });
    }
}

function* updateLearnFeed(api) {
    const currentModule = yield select((state) => state.app.modalData.before.module);

    const cardId = currentModule.id;
    const res = yield api.updateCardInstance(currentModule.parent_id);

    if (res.ok) {
        const { children } = res.data;
        let completed = 0;
        let remaining = 0;
        let pastDue = 0;
        res.data.due_at = res.data.due_at ? moment(split(' ', res.data.due_at)[0]).format('MM/DD/YYYY') : '';

        for (let child of children) {
            child.due_at = child.due_at ? moment(split(' ', child.due_at)[0]).format('MM/DD/YYYY') : '';
            child.data.video_url = convertUrl(child.data.video_url);
            child.data.thumb_url = convertUrl(child.data.thumb_url);

            if (child.status === 3) completed++;
            else if (child.status === 2) pastDue++;
            else remaining++;

            if (child.id === cardId) {
                const modalData = yield select((state) => state.app.modalData);
                yield put(
                    AppActions.modalRequest({
                        type: null,
                        data: { ...modalData, before: { ...modalData.before, module: child } },
                    })
                );
            }
        }
        const updatedCourse = {
            ...res.data,
            children,
            data: { ...res.data.data, completed, remaining, past_due: pastDue },
        };

        const currentCards = yield select((state) => state.develop.templates.trainings.data);
        const updatedCards = [];
        for (const card of currentCards) {
            if (card.id === updatedCourse.id) updatedCards.push(updatedCourse);
            else updatedCards.push(card);
        }

        const modalData = yield select((state) => state.app.modalData);
        yield put(
            AppActions.modalRequest({
                type: null,
                data: { ...modalData, before: { ...modalData.before, course: updatedCourse } },
            })
        );

        const templates = yield select((state) => state.develop.templates);
        yield put(
            DevelopActions.getlibrarytemplatessearchSuccess('trainings', {
                ...templates.trainings,
                data: updatedCards,
            })
        );
    }
}

export function* programeventRequest(api, action) {
    try {
        const { event, data, after } = action.payload;
        const { callback } = action;
        const response = yield api.postProgramEvent(event, data);
        const program = data?.program_type ? data?.program_type : 'program';
        let msg = '';
        if (response.ok) {
            if (event === 'start') {
                msg = `The ${program} was successfully started`;
            } else if (event === 'stop') {
                msg = `The ${program} was successfully stopped`;
            } else if (event === 'delete') {
                if (response.data?.status === 'error') {
                    toast.error(`Deleting the ${program} was failed, please try it later.`, {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    yield put(DevelopActions.programeventFailure());
                    return;
                }
                msg = `The ${program} was successfully deleted`;
            } else {
                msg = `The ${program} was successfully moved to next level`;
            }
            if (!isNil(after) && !isEmpty(after)) yield put({ ...after });
            toast.success(msg, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.programeventSuccess(response.data));
            if (callback) yield callback();
        } else {
            if (response.data?.message && response.data?.program?.id) {
                const res = yield api.postProgramEvent('delete', { program: { id: response.data.program.id } });
                if (res.ok) {
                    yield put(action);
                    return;
                }
            }
            msg = response.data?.message ?? `Updating the ${program} was failed, please try it later.`;
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.programeventFailure());
        }
    } catch (e) {
        yield put(DevelopActions.programeventFailure());
    }
}

export function* programpromotionRequest(api, action) {
    try {
        const { programId, route = null, after = null } = action.payload;
        const response = yield api.getProgramRequestPromotion(programId);

        if (response.ok) {
            yield put(DevelopActions.programpromotionSuccess());
            if (after) yield put({ ...after });
            if (route) yield call(NavigationService.push, route);
        } else {
            toast.error('Your request was failed, please try it later.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.programpromotionFailure());
        }
    } catch (e) {
        yield put(DevelopActions.programpromotionFailure());
    }
}

export function* postterminateuserRequest(api, action) {
    try {
        const { payload, companyId, event } = action;
        const response = yield api.postTerminateUser(payload, companyId, event);

        if (response.ok) {
            toast.success(`User has been ${event} successfully.`, {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.postterminateuserSuccess());
            yield put(AppActions.postmulticompanydataRequest());
        } else {
            yield put(DevelopActions.postterminateuserFailure());
        }
    } catch (e) {
        yield put(DevelopActions.postterminateuserFailure());
    }
}

export function* postdeleteuserRequest(api, action) {
    try {
        const { userId, companyId } = action;
        const response = yield api.postDeleteUser(userId);
        if (response.ok) {
            toast.success('User has been deleted successfully.', {
                position: toast.POSITION.TOP_RIGHT,
            });
            yield put(DevelopActions.postdeleteuserSuccess());
            yield put(AppActions.postmulticompanydataRequest());
            yield put(CompanyActions.getminimalcompanyemployeesRequest(companyId, 1));
        } else {
            toast.error('Your request was failed, please try it later.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            yield put(DevelopActions.postdeleteuserFailure());
        }
    } catch (e) {
        yield put(DevelopActions.postdeleteuserFailure());
    }
}

export function* getassessmentsRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.getAssessments(payload);
        if (response.ok) {
            yield put(DevelopActions.getassessmentsSuccess(response.data));
        } else {
            yield put(DevelopActions.getassessmentsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getassessmentsFailure());
    }
}

export function* getuserprogramsRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.getUserPrograms(payload);
        if (response.ok) {
            yield put(DevelopActions.getuserprogramsSuccess(response.data));
        } else {
            yield put(DevelopActions.getuserprogramsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getuserprogramsFailure());
    }
}

export function* getuserscorecardsRequest(api, action) {
    try {
        const { payload } = action;
        const response = yield api.getUserScorecards(payload);
        if (response.ok) {
            yield put(DevelopActions.getuserscorecardsSuccess(response.data));
        } else {
            yield put(DevelopActions.getuserscorecardsFailure());
        }
    } catch (e) {
        yield put(DevelopActions.getuserscorecardsFailure());
    }
}
